export function areRecordReadsUnchanged(log, previous, next) {
    if (previous === next)
        return true;
    if (log.enumerated)
        return false;
    for (const [key, value] of log.reads) {
        if (!Object.is(Reflect.get(next, key), value))
            return false;
    }
    return true;
}
